// extracted by mini-css-extract-plugin
export default {"textarea":"_YAWLH4V1t8MJ6TVzPcG","footer":"XxiDOHipDcL75Ye91b6K"};